import React from "react";
import {
  Dimensions,
  FlatList,
  StatusBar,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import Medical from "../components/Medical";
import { AntDesign } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import { useSelector } from "react-redux";
import { selectMedicalList } from "../store/medicalSlice";
import { selectIdentityList } from "../store/identitySlice";
import HomeIdentity from "../components/HomeIdentity";

const HomeScreen = () => {
  const navigation = useNavigation();

  const addMedical = () => {
    navigation.navigate("Medical");
  };

  const myQr = () => {
    navigation.navigate("Qr");
  };

  const medicalList = useSelector(selectMedicalList);
  const identityList = useSelector(selectIdentityList);

  return (
    <View style={styles.home}>
      <TouchableOpacity onPress={addMedical}>
        <View style={styles.homeAddButton}>
          <AntDesign name="plus" size={24} color="#F8F8F8" />
        </View>
      </TouchableOpacity>

      <View style={styles.homeIdentity}>
        <FlatList
          data={identityList}
          renderItem={({ item }) => <HomeIdentity item={item} />}
          keyExtractor={({ id }) => id}
          showsVerticalScrollIndicator={false}
        />
      </View>

      { medicalList.length > 0 && (
        <FlatList
          data={medicalList}
          renderItem={({ item }) => <Medical item={item} />}
          keyExtractor={({ id }) => id}
          showsVerticalScrollIndicator={false}
          style={{ marginBottom: 75 }}
        />
      )}

      <TouchableOpacity onPress={myQr}>
        <View style={styles.homeButton}>
          <Text style={styles.homeButtonText}>Show My Qr</Text>
        </View>
      </TouchableOpacity>
    </View>
  );
};

export default HomeScreen;

const styles = StyleSheet.create({
  home: {
    paddingHorizontal: "10vw",
    paddingTop: StatusBar.currentHeight,
    flex: 1,
    maxHeight: Dimensions.get("window").height,
  },
  homeAddButton: {
    position: "absolute",
    right: -20,
    top: 20,
    backgroundColor: "#FF2828",
    borderRadius: 100,
    padding: 10,
    zIndex: 4,
  },
  homeIdentity: {
    borderWidth: 3,
    borderColor: "#FF2828",
    borderRadius: 15,
    paddingHorizontal: "5vw",
    paddingVertical: "1.5vh",
    marginTop: 30,
    marginBottom: 50,
    zIndex: -1,
  },
  homeIdentityName: {
    fontSize: 24,
    fontWeight: "500",
  },
  homeIdentityBirth: {
    fontSize: 16,
    fontWeight: "500",
    marginVertical: 5,
  },
  homeIdentityAddress: {
    fontSize: 16,
    fontWeight: "500",
  },
  homeButton: {
    backgroundColor: "#FF2828",
    paddingVertical: 10,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 5,
    position: "absolute",
    bottom: 20,
    width: "100%",
  },
  homeButtonText: {
    color: "#F8F8F8",
    fontWeight: "500",
    fontSize: 16,
  },
});
